<template>
  <div>
    <label
      v-if="label"
      class="pl-2 label-text"
    >
      {{ label }}
      <v-icon
        v-if="required"
        class="uikit-icon mini-star size-mini-star error"
      />
    </label>
    <v-autocomplete
      class="mt-0 rounded-lg mini-text base-select field-edit"
      v-model="dataValue"
      :items="items || []"
      :item-value="itemValue"
      :item-text="itemText"
      no-data-text="Список пуст"
      autocomplete="new-password"
      outlined
      dense
      clearable
      :hide-no-data="hideNoData"
      :no-filter="noFilter"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :item-disabled="itemDisabled"
      :return-object="returnObject"
      :class="{
        'field-error': errorMessages && errorMessages.length,
        'hide-input': noChangeHeight && multiple && dataValue.length
      }"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :search-input.sync="search"
      :multiple="multiple"
      :hint="hint"
      :persistent-hint="persistentHint"
    >
      <template>
        <div
          slot="append"
          class="d-flex align-center"
        >
          <v-icon class="uikit-icon chevron-down size-24 delay-03" />
        </div>
      </template>

      <template
        v-slot:selection="data"
        v-if="multiple"
      >
        <v-chip
          class="ma-1"
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="select(data.item)"
        >
          {{ getText(data.item) }}
        </v-chip>
        <!--        <span v-else-if="data.index === 0"> {{`выбрано значений: ${dataValue.length}`}} </span>-->
      </template>

      <template v-slot:item="data">
        <v-list-item
          v-on="!multiple ? data.on : null"
          v-bind="data.attrs"
          :class="
            dataValue &&
            (multiple
              ? dataValue.length &&
                dataValue.some(el =>
                  returnObject ? data.item[itemValue] === el[itemValue] : data.item[itemValue] === el
                )
              : returnObject
              ? data.item[itemValue] === dataValue[itemValue]
              : data.item[itemValue] === dataValue)
              ? 'base-select-active'
              : ''
          "
          @click="select(data.item)"
        >
          <v-icon
            v-if="
              dataValue &&
              (multiple
                ? dataValue.length &&
                  dataValue.some(el =>
                    returnObject ? data.item[itemValue] === el[itemValue] : data.item[itemValue] === el
                  )
                : returnObject
                ? data.item[itemValue] === dataValue[itemValue]
                : data.item[itemValue] === dataValue)
            "
            style="margin-right: 12px"
            class="uikit-icon check lightGrey size-20"
          />
          <v-list-item-content>{{ getText(data.item) }}</v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'UIAutocomplete',

  props: {
    label: String,
    value: {
      type: [Object, Number, String, Array, null],
      default: null
    },
    items: Array,
    itemText: {
      type: [String, Function],
      default: 'name'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    noFilter: {
      type: Boolean,
      default: true
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Выбрать из списка'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    itemDisabled: {
      type: Function,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: true
    },
    searchInput: {
      type: String,
      default: ''
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    noChangeHeight: {
      type: Boolean,
      default: false
    },
    hideNoData: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /*    getText(item) {
          //return this.dataValue ? this.dataValue[this.itemText] : ''
        },*/

    search: {
      get() {
        return this.searchInput
      },
      set(val) {
        this.$emit('update:search-input', val)
        this.$emit('searchData', val)
      }
    },

    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },

  methods: {
    select(item) {
      if (this.multiple) {
        const index = this.returnObject
          ? this.dataValue.findIndex(el => item[this.itemValue] === el[this.itemValue])
          : this.dataValue.findIndex(el => item[this.itemValue] === el)
        index === -1
          ? this.dataValue.push(this.returnObject ? item : item[this.itemValue])
          : this.dataValue.splice(index, 1)

        this.$emit('input', this.dataValue)
        this.$emit('change', this.dataValue)
      } else {
        this.dataValue = this.returnObject ? cloneDeep(item) : item[this.itemValue]
      }
    },

    getText(item) {
      return typeof this.itemText === 'function' ? this.itemText(item) : item[this.itemText]
    }
  }
}
</script>

<style scoped>
.base-select-active {
  background: var(--v-lightGrey3-base) !important;
}

.base-select.v-select--is-menu-active .chevron-down {
  transform: rotate(180deg);
}

.base-select.hide-input >>> input {
  min-height: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.base-select.hide-input >>> .v-select__selections {
  max-height: 100px !important;
}

.base-select.hide-input >>> .v-select__slot {
  overflow-y: auto;
  overflow-x: hidden;
}

.base-select.hide-input >>> .v-input__slot {
  padding-bottom: 2px !important;
  padding-top: 1px !important;
  padding-right: 0px !important;
}

.base-select.hide-input >>> .chevron-down {
  margin-right: 4px !important;
}

.base-select >>> .v-chip__content {
  overflow-x: hidden !important;
  margin-right: 12px;
}

.base-select .v-chip >>> .v-chip__close {
  position: absolute;
  right: 8px;
}
</style>
